import React, { useEffect, useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { get, lowerCase, map } from "lodash";
import { withTranslation } from "react-i18next";

//i18n
import i18n from "../../../i18n";
import { fetchLanguageList } from "helpers/backend_api_helper";

const LanguageDropdownWithoutLogin = ({ selectedLanguage }) => {
  // Declare a new state variable, which we'll call "menu"
  const [languageList, setLanguageList] = useState([])
  const [selectedLang, setSelectedLang] = useState("");
  const [menu, setMenu] = useState(false);

  useEffect(() => {
    const currentLanguage = localStorage.getItem("I18N_LANGUAGE");
    setSelectedLang(currentLanguage);
  }, [])

  const changeLanguageAction = (lang, data) => {
    //set language as i18n
    i18n.changeLanguage(lang);
    localStorage.setItem("I18N_LANGUAGE", lang);
    localStorage.setItem("language_id", data?.id);
    setSelectedLang(lang);
    selectedLanguage(lowerCase(lang));
  }


  const toggle = () => {
    setMenu(!menu);
  }

  const fetchLanguageLists = async () => {
    const listLang = await fetchLanguageList();
    setLanguageList(listLang?.data);
    // setLanguageList((prevState) => [...listLang.data, ...prevState]);
  }

  useEffect(() => {
    fetchLanguageLists()
  }, [])

  return (
    <>
      <Dropdown isOpen={menu} toggle={toggle} className="d-inline-block header-lang-choose-btn">
        <DropdownToggle className="btn header-item lang-button" tag="button">
          {/* <img
            src={get(languages, `${selectedLang}.flag`)}
            alt="Schor"
            height="16"
            className="me-1"
          /> */}
          <span className="align-middle">
            {/* {selectedLang} */}

            {selectedLang === "EN" ? "English" :
              selectedLang === "FR" ? "French" :
                selectedLang === "IU" ? "Inuktitut" :
                  selectedLang === "ES" ? "Spanish" :
                    selectedLang === "AR" ? "Arabic" :
                      selectedLang === "DE" ? "German" :
                        "Kurdish"
            }
          </span>
        </DropdownToggle>
        <DropdownMenu className="language-switch dropdown-menu-end">
          {
            languageList?.map((data) => {
              return (
                <DropdownItem
                  key={data?.code}
                  onClick={() => changeLanguageAction(data?.code, data)}
                  className={`notify-item ${selectedLang === data?.code ? "active" : "none"}`}
                >
                  <span className="align-middle">
                    {data?.label}
                  </span>
                </DropdownItem>
              )
            })
          }
        </DropdownMenu>
      </Dropdown>
    </>
  )
}

export default withTranslation()(LanguageDropdownWithoutLogin)
